<template>
	<div class="main" >
  <!--   <h2
      v-if="title"
      class="title">
      {{title}}
    </h2> -->
      <el-row :gutter="20" id="telnetTable" class="telnetTable_rows">
        <el-col :span="6">
          <!-- treeData Start-->
          <h5>选择计量器设备</h5>
          <div class="telnetMenu">
            <el-input
              style="margin-bottom: 3px"
              placeholder="输入关键字进行过滤"
              v-model="filterTreeText">
            </el-input>
            <el-tree
              class="filter-tree"
              node-key="id"
              ref="deviceTree"
              :style="{height: treeHeight + 'px'}"
              :highlight-current="true"
              :data="treeData"
              :props="defaultProps"
              :filter-node-method="filterTreeNode"
              @node-click="getTreeData">
            </el-tree>
          </div>
           <!-- treeData End-->
        </el-col>
        <el-col :span="18">
            <div class="improtantInfo-box" >
              <div class="telnetHeader">
                <h5 class="inline-block"></h5>
                <div>
                  <el-button v-if="isChooseCountor" type="primary" class="button"
                  :disabled="postDisabled"
                  @click="postWatermeterRecord('', true)"
                  >{{statusText}}</el-button>
                  <el-button v-if="isChooseCountor" type="primary" plain class="button" @click="setDataBack">回填</el-button>
                </div>
              </div>
              <div class="telnetDetailInfo">
                <CollapseInfo :infoList="collapseList" class="collapseInfo">
                  <div slot="device"><ImportantInfo
                  :infoList="infoList"
                  :formValues="infoValues"
                  :columns="columns">
                  </ImportantInfo></div>
                  <div slot="user"><ImportantInfo
                  :infoList="userInfoList"
                  :formValues="infoValues"
                  :columns="columns">
                  </ImportantInfo></div>
                </CollapseInfo>
              </div>
            </div>
             <!-- ImportantInfo End-->
            <div class="chartsInfo-box">
              <div class="chartsInfo-body">
                <FilterBox
                  v-if="isChooseCountor"
                  class="filter-box inline-block"
                  :columns="columns"
                  :filterList="filterList"
                  :filterBy="filterBy"
                  @changeFilterBy="changeFilterBy">
                </FilterBox>
                <Tab
                    :tabList="tabList"
                    :path="path"
                    ref="tabList">
                  <div slot="echartLine" class="echartBox" v-if="isChangeChart" :style="echartStyle">
                    <div class="dataChart" id="dataChart" ref="dataChart" :style="echartStyle"></div>
                  </div>
                  <div slot="lists" class="lists-box">
                    <DataTable
                      mainColumn="image"
                      longColumn="image"
                      :isLoading="isLoading"
                      :tableList="tableList"
                      :columns="columns"
                      :tableData="tableData"
                      :tableWrapperWidth="tableWrapperWidth"
                      :operationList="operationList">
                    </DataTable>
                    <el-row class="page">
                      <el-pagination
                        class="pagination"
                        layout="total, sizes, prev, pager, next"
                        :page-sizes="[10, 25, 50, 100]"
                        :page-size="pageSize"
                        :current-page="pageIndex"
                        :total="recordsFiltered"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange">
                      </el-pagination>
                    </el-row>
                  </div>
                </Tab>
                <!-- chartsInfo-body_Tabs End-->
              </div>
            </div>
        </el-col>
      </el-row>
      <div v-if="isLoading" class="v-modal noData">
        <span class="loading-wrapper"><span class="loading"></span></span>
          加载中...
      </div>
      <ImageLightbox
        v-if="lightboxShow"
        v-model="lightboxVisable"
        ref="lightbox"
        :imageDesc="lightImageDesc"
        :showCaption="lightBoxShowCaption"
        :lightBoxImgs="lightBoxImgs">
      </ImageLightbox>
  </div>
</template>
<script>
import ImportantInfo from '@/components/ImportantInfo'
import CollapseInfo from '@/components/CollapseInfo'
import DataTable from '@/components/DataTable'
import columns from './columns.js'
import moment from 'moment'
import Echarts from 'echarts'
import { fetch, fetchItem, fetchList, fetchUpdate } from '@/utils/api'
// import { operationSeePics } from '@/containers/DataTablePage/operation'
import {treeFormat, URL} from '@/utils/common.js'
import Tab from '@/components/Tab'
import FilterBox from '@/components/FilterBox'
import ImageLightbox from '@/components/ImageLightbox'

import { valueFormat } from '@/utils/common'
import { expire } from '@/utils/auth'

export default {
  name: 'DeviceInfo',
  components: {
    ImportantInfo,
    CollapseInfo,
    Echarts,
    // SmartTree,
    Tab,
    FilterBox,
    DataTable,
    ImageLightbox
  },
  data () {
    const tabList = [{label: '水量折线图', name: 'echartLine'}, {label: '水量数据列表', name: 'lists'}]
    return {
      imagePopover: false,
      lightboxVisable: false,
      lightImageDesc: '',
      lightBoxImgs: [],
      lightBoxShowCaption: false,
      postDisabled: false, // 点抄按钮是否允许操作
      isLoading: false,
      isTree: false,
      isChooseCountor: false,
      isChooseArea: false,
      isChangeChart: true,
      filterTreeText: '',
      title: '抄表信息',
      statusText: '点抄',
      path: '/telnetReading/deviceInfo',
      infoList: ['name', 'code', 'payloadTypeId', 'collectorName', 'collectorCode', 'collectorPayloadTypeId', 'port', 'baudrate', 'rateNumber', 'electric', 'largeType', 'smallType', 'deviceType'],
      infoValues: {},
      userInfoList: ['hno', 'hname', 'phone', 'mobile', 'addr', 'time', 'totalData'],
      userInfoValues: {},
      tableList: ['time', 'totalData', 'image'],
      tableData: [],
      filterList: ['time'],
      filterBy: [],
      treeData: [],
      listsInfo: [], // 数据列表
      currentCountId: 0,
      firstCollectId: 0,
      pageSize: Number(this.$route.query.pageSize) || 10,
      pageIndex: Number(this.$route.query.pageIndex) || 1,
      recordsFiltered: 0,
      recordsTotal: 0,
      relationKeys: ['payloadTypeId', 'countersAll', 'collectorTypeId', 'counterTypeId'],
      columns: {
        ...columns,
        series: {
          label: '序号',
          type: 'custom',
          width: 60,
          customRender (data, full, index) {
            return Number(index) + 1
          }
        },
        hno: {
          label: '户号',
          type: 'input',
          size: 8,
          width: 100,
          filter: {
            type: 'input',
            width: 100,
            like: true
          },
          form: {
            type: 'input'
          }
        },
        hname: {
          label: '户名',
          type: 'input',
          size: 8,
          width: 100,
          filter: {
            type: 'input',
            width: 100,
            like: true
          },
          form: {
            type: 'input'
          }
        },
        time: {
          label: '上次抄表时间',
          type: 'time',
          width: 120,
          minLength: 999,
          size: 8,
          dataType: 'YYYY-MM-DD',
          filter: {
            type: 'daterange'
          },
          form: {
            type: 'date',
            rules: [
              { type: 'number', required: true, message: '请选择开始时间', trigger: 'change' }
            ]
          }
        },
        totalData: {
          label: '上次抄表数据',
          size: 8,
          width: 140,
          style: {
            'text-align': 'center'
          }
        },
        image: {
          label: '抄表行码',
          width: 200,
          type: 'custom',
          html: true,
          magnifying: {
            height: '180px',
            width: '200px'
          },
          // minLength: 999,
          customRender (data, full, index) {
            return `<img src="${URL}/${data}" style="height:24px"></img>`
          }
        }
      },
      defaultProps: {
        children: 'children',
        label: 'label'
      }, // 树状参数设置
      dCharts: {},
      echartOptions: {
        title: { text: '水量日期表', subtext: '' },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          show: true,
          feature: {
            mark: {show: true},
            // dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        grid: {
          bottom: '2%',
          containLabel: true
        },
        legend: {
          data: ['水量']
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [],
        totalData: []
      },
      collapseList: [{ title: '设备信息', name: 'device' }, { title: '用水户信息', name: 'user' }],
      tabList: tabList,
      tabName: this.$route.query.state || tabList[0].name,
      operationList: [],
      totalDatas: [],
      treeHeight: document.body.clientHeight - 80,
      tabHeight: document.body.clientHeight - 250,
      tabWidth: document.body.clientWidth - 500
    }
  },
  computed: {
    echartStyle () {
      return {
        width: this.tabWidth - 150 + 'px',
        height: this.tabHeight - 150 + 'px'
      }
    },
    lightboxShow () {
      return this.lightboxVisable
    },
    imagesList () {
      return this.lightBoxImgs.map(res => {
        return {
          thumb: res,
          src: res,
          caption: `<h4>${this.lightImageDesc}</h4>`
        }
      })
    },
    clientWidth () {
      return document.body.clientWidth
    },
    tableWrapperWidth () {
      // if (this.tableWidth) {
      //   return this.tableWidth
      // }
      return this.clientWidth - (this.menuActive ? 210 : 0) - ((this.clientWidth > 991) ? 70 : 0) - 200 - 160
      // return this.tabWidth - 120
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.resetTreeHeight()
    this.initChart()
    this.getRelation()
  },
  beforeDestroy () {
    window.clearInterval(this.progressListener)
  },
  watch: {
    filterTreeText (val) {
      this.$refs.deviceTree.filter(val)
    },
    '$route' (to) {
      const { pageIndex, pageSize, state } = to.query
      this.pageIndex = Number(pageIndex) || 1
      this.pageSize = Number(pageSize) || 10
      // this.filterBy = this.filterTextToFilterBy(filterBy)
      // this.orderBy = this.orderTextToOrderBy(orderBy)
      this.tabName = state
      this.getCounterInfo()
      this.getEchartHeight()
    },
    treeHeight (val) {
      this.treeHeight = val
    }
  },
  methods: {
    getEchartHeight () {
      this.tabHeight = this.$refs.tabList.$el.clientHeight - 60
      this.tabWidth = this.$refs.tabList.$el.clientWidth - 40
      this.drawEchartsLine(this.totalDatas)
    },
    resetTreeHeight () {
      const that = this
      window.onresize = () => {
        return (() => {
          that.treeHeight = document.body.clientHeight - 80
        })()
      }
    },
    showImagePopover () {
      this.imagePopover = !this.imagePopover
    },
    initChart () {
      this.dCharts = Echarts.init(document.getElementById('dataChart'))
      this.dCharts.setOption(this.echartOptions)
    },
    getRelation () {
      fetch({
        url: '/relation',
        params: {relationList: this.relationKeys.join(',')}
      }).then(data => {
        window.clearInterval(this.progressListener)
        this.isRelation = true
        const columnsList = this.columns
        Object.keys(columnsList).map(key => {
          const relation = columnsList[key].relation
          if (data[relation]) {
            columnsList[key].options = [...columnsList[key].optionsInit || [], ...data[relation]].map(option => {
              const label = option[columnsList[key].labelName || 'label']
              return {
                value: option.value !== undefined ? option.value : option.id,
                label,
                ...option
              }
            })
          }
        })
        let counterAlls = []
        data.countersAll.forEach(item => {
          if (item.meterType) {
            if (item.meterType === 'METER_DEFAULT') {
              counterAlls.push(item)
            }
          } else {
            counterAlls.push(item)
          }
        })
        this.treeData = treeFormat(counterAlls, 'value')
        this.$emit('getRelation', columnsList)
      })
    },
    getCounterInfo () {
      if (!this.currentCountId) return
      this.isChooseArea = false // 需要支持点抄和回填数据对区域和计量器的处理
      this.isLoading = true
      window.clearInterval(this.progressListener)
      fetchList({
        resource: '/meterPayload/data/totalData/' + this.currentCountId,
        filterBy: this.filterBy.map(item => {
          if (Object.prototype.toString.call(item.value) === '[object Array]') {
            return item.name + '|' + item.type + '|[' + item.value + ']'
          } else {
            return item.name + '|' + item.type + '|' + item.value
          }
        }).join(';'),
        orderBy: this.orderByToOrderText([{name: 'time', sort: 'desc'}]),
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      }).then(res => {
        this.isLoading = false
        this.isChooseCountor = true
        this.infoValues = res.counter
        this.totalDatas = res.totalDatas
        if (res.totalDatas) {
          this.tabName === 'lists' ? this.listDataRender(res) : this.drawEchartsLine(res.totalDatas)
          const totalDatas = this.tabName === 'lists' ? res.totalDatas[0] : res.totalDatas[res.totalDatas.length - 1]
          this.infoValues = {
            ...res.counter,
            ...totalDatas // 倒序的话显示第一条totalDatas数据
          }
        }
        console.info('res.counter:', res.counter)
        if (res.counter && res.counter.status) {
          const status = res.counter.status
          if (status === '' || status === 'failed') return
          if (status === 'finish') {
            // this.postWatermeterRecord('点抄成功')
            this.postDisabled = false
            this.statusText = '点抄'
            // this.listenReadingStatus()
          } else {
            this.changeRecordStatus(res.counter)
          }
        }
      }).catch(err => {
        console.info('err::', err)
      })
    },
    getTreeData (data, node) {
      const counterId = node.data.value.replace(/[^0-9]/ig, '')
      this.isChooseArea = true
      if (node.data.type === 'counter') {
        this.currentCountId = counterId
        this.getCounterInfo()
      }
    },
    // 数据列表
    listDataRender (datas) {
      datas.totalDatas.map(res => { res['id'] = res.time })
      this.tableData = datas.totalDatas
      this.recordsFiltered = datas.recordsFiltered
      this.recordsTotal = datas.recordsTotal
    },
    // 设置折线图数据
    setEchartsOption (datas = []) {
      // this.isChangeChart = false
      let xAxis = []
      let totalData = []
      const newDatas = datas.reverse()
      if (newDatas.length) {
        xAxis = newDatas.map(data => { return this.timeRender(new Date(data.time), 'YYYY-MM-DD HH:mm:ss') })
        totalData = newDatas.map(data => { return data.totalData })
      } else {
        xAxis = newDatas.map(data => { return this.timeRender(new Date(), 'YYYY-MM-DD HH:mm:ss') })
      }
      // option['yAxis'] = option.totalData.length ? {min: Math.min.apply(null, option.totalData)} : {}
      return {
        xAxis,
        totalData
      }
    },
    // 画折线图
    drawEchartsLine (datas = []) {
      const {xAxis, totalData} = this.setEchartsOption(datas)
      let echartOptions = this.echartOptions
      const subText = totalData.length ? '' : '该设备暂无用水总量'
      echartOptions['title'] = Object.assign(echartOptions['title'], {subtext: subText})
      echartOptions['xAxis'].data = xAxis
      // echartOptions['yAxis'] = elTotalData.length ? {min: Math.min.apply(elTotalData.data, totalData)} : {min: Math.min.apply(null, totalData)}
      const series = {
        name: '水量',
        type: 'line',
        stack: '总量',
        data: totalData || [],
        markPoint: {
          data: [{type: 'max', name: '最大值'}, {type: 'min', name: '最小值'}]
        },
        markLine: {
          data: [{type: 'average', name: '平均值'}]
        }
      }
      echartOptions['series'] = [series]
      this.dCharts.setOption(echartOptions)
      // console.info('echartOptions:', echartOptions)
    },
    changeTotalData (datas = [], index = 0) {
      // 点抄时候折线图数据刷新
      const {xAxis, totalData} = this.setEchartsOption(datas)
      let echartOptions = this.echartOptions
      let {xAxis: oldxAxis, series: oldSeries} = echartOptions
      oldxAxis.data = [].concat(oldxAxis.data, xAxis)
      oldSeries[index].data = [].concat(oldSeries[index].data, totalData)
      this.dCharts.setOption(echartOptions)
    },
    filterTreeNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    /* 点抄-- 根据后台返回的status状态改变，只有processing会每隔3秒轮询点抄接口
      初始页面根据列表接口返回的status，如果为finsh或ready，需要再次调用点抄接口查询到状态
      如果为processing时，则进行轮询
    */
    postWatermeterRecord (statusText = '正在点抄中...', isClick = false) {
      console.info('isClick:', isClick)
      this.statusText = statusText
      fetchItem({
        resource: '/meterPayload/data/totalDataCopy',
        id: this.currentCountId
      }).then(data => {
        // console.info('postWatermeterRecord:', data)
        if (!data) {
          this.changeRecordStatus(data)
          return
        }
        if (data.totalData.totalData) {
          this.changeTotalData([data.totalData])
          this.infoValues = {
            ...this.infoValues,
            ...data.totalData
          }
        }
        if (data.status === 'processing' && !isClick) return // 不是第一次点击"点抄"触发的点抄中
        this.changeRecordStatus(data)
      })
    },
    /* 监听请求点抄状态 */
    listenReadingStatus () {
      fetch({
        url: '/meterPayload/data/batchReadingStatus',
        params: {
          ids: this.currentCountId
        }
      }).then(data => {
        // 当前是否还有未点抄完成的，有则继续
        if (data.processingNum) {
          const that = this
          that.progressListener = setTimeout(function () {
            that.listenReadingStatus()
          }, 5000)
        }
        // 有已停止点抄的或不需要继续点抄
        if (data.processingNum === 0) {
          this.changeRecordStatus(data.datas[0])
          this.getCounterInfo()
        }
      })
    },
    /* 根据点抄状态修改显示效果
    *  @data 数据
    */
    changeRecordStatus (data) {
      const {status} = data
      console.info('changeRecordStatus:', status, data)
      if (status === 'ready') {
        // 允许点抄
        window.clearInterval(this.progressListener)
        this.postDisabled = false
        this.statusText = '点抄'
      } else if (status === 'processing') {
        // 点抄中， 3s 定时请求接口
        this.statusText = '正在点抄中...'
        this.postDisabled = true
        this.listenReadingStatus() // 请求点抄状态
      } else if (status === 'finish') {
        // 点抄完成， 弹出结果
        this.postDisabled = false
        window.clearInterval(this.progressListener)
        this.statusText = '点抄'
        this.showFinishSwal(data)
      } else if (status === 'failed' || !status) {
        // 点抄失败， 弹出失败原因
        this.postDisabled = false
        window.clearInterval(this.progressListener)
        this.statusText = '重新点抄'
        this.$swal('点抄失败!', '', 'error')
      }
    },
    /* 弹框显示成功状态 */
    showFinishSwal (datas) {
      const time = this.$moment(datas.time).format('YYYY-MM-DD hh:mm:ss')
      this.$swal({
        title: `点抄成功!`,
        text: `最新点抄${time}的行码${datas.num}`,
        imageUrl: `${URL}/${datas.image}`,
        imageWidth: 200,
        imageHeight: 50,
        imageAlt: 'Custom image',
        animation: true
      })
    },
    timeRender (data, dateType) {
      return data ? moment(data).format(dateType) : '-'
    },
    changeFilterBy (data) {
      this.filterBy = [...data]
      this.getCounterInfo()
    },
    showWatermeterImage (data) {
      const { image, time, totalData } = data
      const date = this.$moment(time).format('YYYY-MM-DD HH:mm:ss')
      if (image) {
        this.lightboxVisable = true
        this.lightBoxImgs = [`${URL}/${image}`]
        this.lightImageDesc = `${date}总用水量：${totalData}`
      } else {
        this.$swal('抱歉，暂无图片', '', 'info')
      }
    },
    pageSizeChange (value) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          pageSize: value
        }
      })
      this.pageIndexChange(1)
    }, /* 每页显示记录数的修改函数 */
    pageIndexChange (value) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          pageIndex: value
        }
      })
    },
    filterTextToFilterBy (filterText) {
      if (!filterText) {
        return []
      }
      return filterText.split(';').map(item => {
        const filter = item.split('|')
        return {
          name: filter[0],
          type: filter[1],
          value: valueFormat(filter[2], this.columnsList[filter[0]].dataType)
        }
      })
    },
    orderByToOrderText (orderBy) {
      return orderBy.map(({name, sort}) => `${name}|${sort}`).join(';')
    },
    orderTextToOrderBy (orderText) {
      if (!orderText) {
        return []
      }
      return orderText.split(';').map(item => {
        const order = item.split('|')
        return {
          name: order[0],
          sort: order[1]
        }
      })
    },
    setDataBack () {
      fetchUpdate({
        resource: `/meterPayload/data/totalDataBackfill`,
        id: this.currentCountId
      }).then(data => {
        if (data) {
          this.$swal('回填成功！', '', 'success')
        }
      })
    } // 数据回填
  }
}
</script>
<style scoped lang="sass">
.main
  padding: 20px
  // padding-top: 0px
  display: flex
  flex-direction: column
  flex: 1
  height: 100%
  box-sizing: border-box
  h2
    margin: 0
.telnetTable_rows
  height: calc(100% - 50px)
  // height: 100vh!important
  // height: calc(100vh - 50px)
  flex: 1
  // margin-bottom: 10px
  // height: 100%
  // padding-bottom: 20px
  >div.el-col
    height: 100%
    display: flex
    flex-direction: column
  .telnetMenu
    height: 100%
    display: flex
    flex-direction: column
  .filter-tree
    // height: calc(100vh - 300px)
    // height: 90%
    flex: 1
    overflow: scroll
  .chartsInfo-box
    height: calc(100% - 120px)
    margin-top: 10px
    margin-bottom: 10px
    // display: flex
    flex-direction: column
    flex: 1
    background: #fff
    .chartsInfo-body
      border: 1px solid #ddd
      height: 100%
      // min-height: 500px
      display: flex
      flex-direction: column
      .filter-box
        padding-top: 10px
        padding-right: 5px
        display: flex
        justify-content: flex-end
      .main
        padding: 0 20px
.telnetDetailInfo
  .important-wrap
    padding-left: 0
    padding-right: 0
    border: 0
.lists-box
  display: flex
  flex-direction: column
  margin-bottom: 5px
  height: 100%
  .table-wrapper
    height: 100%
  .lists
    flex: 1
    border-bottom: 1px solid #ddd
    blockquote>button
      margin-right: 10%
      float: right
    blockquote:before
      content: '' !important
    blockquote:after
      clear: both
  .page
    display: flex
    .pagination
      flex: 1
      padding-top: 12px
      text-align: right
      justify-content: flex-end
.echartBox
  // height: 100%
  // width: 100%
  // margin: 0 auto
  .dataChart
    height: 100%
    width: 100%
    div
      height: 80%!important
      canvas
        height: 100%!important
        width: 100%
.telnetFull
  height: 100%
.noData
  text-align: center
  line-height: 50
  font-size: 18px
  color: #fff
  background: #3e3a3a!important
.inline-block
  display: inline-block
.telnetHeader
  height: 45px
  display: flex
  justify-content: space-between
  align-items: center
  padding-bottom: 10px
  .button
    width: 100px
</style>


// WEBPACK FOOTER //
// DeviceInfo.vue?3d593e64